import { render, staticRenderFns } from "./LoginForSso.vue?vue&type=template&id=1bbb3970&scoped=true&"
import script from "./LoginForSso.vue?vue&type=script&lang=js&"
export * from "./LoginForSso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb3970",
  null
  
)

export default component.exports